import { CommonModule } from '@angular/common';
import { Component, ElementRef, inject, OnDestroy, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatToolbarModule } from '@angular/material/toolbar';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterEvent, RouterModule, RouterOutlet } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { ApplicationService } from './services';
import { CUSTOMER_SERVICE_EMAIL, CUSTOMER_SERVICE_MAILTO, MessageType } from '@models';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule, FormsModule, ReactiveFormsModule, RouterModule, RouterOutlet,
    MatIconModule, MatListModule, MatToolbarModule, MatProgressSpinnerModule,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {
  applicationService = inject(ApplicationService);
  elementRef = inject(ElementRef);
  router = inject(Router);

  MessageType = MessageType;
  CUSTOMER_SERVICE_EMAIL = CUSTOMER_SERVICE_EMAIL;
  CUSTOMER_SERVICE_MAILTO = CUSTOMER_SERVICE_MAILTO;

  busy = this.applicationService.busy;
  companySite = this.applicationService.companySite;
  messages = this.applicationService.messages;
  title = 'Bat Warranty System';
  unsubscribe = new Subject<void>();

  constructor() {
    this.router.events.pipe(takeUntil(this.unsubscribe))
      .subscribe((routerEvent) => {
        this.checkRouterEvent(routerEvent as RouterEvent);
      });
  }

  ngOnInit(): void {
    globalThis.addEventListener('resize', () => {
      setTimeout(() => {
        const vh = globalThis.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
        const vw = globalThis.innerWidth * 0.01;
        document.documentElement.style.setProperty('--vw', `${vw}px`);
      }, 400);
    });

  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
  }

  onClear(): void {
    this.applicationService.clearMessages();
  }

  hasCustomerServiceEmail(message: string): boolean {
    return message?.includes(this.CUSTOMER_SERVICE_EMAIL);
  }

  getMessageBeforeCustomerServiceEmail(message: string): string {
    return message?.split(this.CUSTOMER_SERVICE_EMAIL)?.[0] ?? '';
  }

  getMessageAfterCustomerServiceEmail(message: string): string {
    return message?.split(this.CUSTOMER_SERVICE_EMAIL)?.[1] ?? '';
  }

  checkRouterEvent(routerEvent: RouterEvent): void {
    if (routerEvent instanceof NavigationStart) {
      this.applicationService.busy.set(1);
    }

    if (routerEvent instanceof NavigationEnd ||
      routerEvent instanceof NavigationCancel ||
      routerEvent instanceof NavigationError) {
      this.applicationService.busy.set(0);
    }
  }

}
